import {Component, EventEmitter, Input, Output} from '@angular/core';

@Component({
  selector: 'app-modal-wholesalers',
  templateUrl: './modal-wholesalers.component.html',
  styleUrls: ['./modal-wholesalers.component.scss']
})
export class ModalWholesalersComponent {
  @Output()
  darkLayerChange: EventEmitter<boolean> = new EventEmitter();

  public isModalWholesalersShow: boolean = false;
  public isDarkBackground: boolean = false;

  openModalWholesalerShow() {
    this.isModalWholesalersShow = true;
    this.isDarkBackground = true;
  }

  closeModal() {
    this.isModalWholesalersShow = false;
    this.isDarkBackground = false;
  }
}
